export default "/images/power.svg?81d324791099948106e7f86e2a7cda01";